import type { MediaProps } from './Media';

/**
 * Checks whether a media object is empty
 */
export function hasMedia(media?: MediaProps) {
  return media && (media?.src || media?.embed || media?.children);
}
